@if (attachForm) {
  <div [formGroup]="attachForm">
    <div class="flex flex-column gap-1">
      <div>
        @if (renderHeader) {
          <div class="flex">
            @if (tagesgeldMitBestand || korrektur) {
              <label class="text-black-alpha-60" for="sysEinstand" [style]="{'margin-left': '136px'}">
                {{ "investment.label.zins.geschaeft" | translate }}
              </label>
              <label class="text-black-alpha-60" for="sysEinstand" [style]="{'margin-left': '30px'}">
                {{ "investment.label.zins.system" | translate }}
              </label>
              <label class="text-black-alpha-60" for="eingEinstand" [style]="{'margin-left': '38px'}">
                {{ "investment.label.zins.eingabe" | translate }}
              </label>
            } @else if (storno) {
              <label class="text-black-alpha-60" for="eingEinstand" [style]="{'margin': 'auto'}">
                {{ "investment.label.zins.eingabe" | translate }}
              </label>
            } @else {
              <label class="text-black-alpha-60" for="sysEinstand" [style]="{'margin-left': '135px'}">
                {{ "investment.label.zins.system" | translate }}
              </label>
              <label class="text-black-alpha-60" for="eingEinstand" [style]="{'margin-left': '80px'}">
                {{ "investment.label.zins.eingabe" | translate }}
              </label>
            }
          </div>
        }
      </div>
      @if (isDzUser) {
        <div class="flex flex-row align-items-center w-28rem">
          <label class="w-13rem" for="sysEinstand">
            {{ "investment.label.zins.einstand" | translate }}
          </label>
          <p-input-group>
            @if (!storno) {
              @if (tagesgeldMitBestand || korrektur) {

                <!-- EINSTAND Geschaeft -->
                <p-iconfield class="form-zins-spinner" no-border-right>
                  <input [class.text-error]="!hasGeschInterestRate()" pInputText formControlName="geschEinstand"
                         class="w-full text-right"/>
                </p-iconfield>
              }

              <!-- EINSTAND System -->
              <p-iconfield [attr.no-border]="(korrektur || tagesgeldMitBestand) ? '' : null"
                           [attr.no-border-right]="!korrektur ? '' : null"
                           class="form-zins-spinner">
                @if (isInterestLoading()) {
                  <p-inputicon class="pi pi-spinner pi-spin"/>
                }
                <input pInputText inputStyleClass="text-right" id="sysEinstand" formControlName="systemEinstand"
                       class="w-full text-right" [class.text-error]="!hasInterestRate()"/>
              </p-iconfield>
            }
            <!-- EINSTAND Eingabe -->
            <p-iconfield [attr.no-border]="!storno ? '' : null" [attr.no-border-right]="storno ? '' : null"
                         iconPosition="left"
                         [class.w-full]="storno"
                         class="form-zins-spinner">
              @if (isInterestLoading()) {
                <p-inputicon class="pi pi-spinner pi-spin"/>
              }
              <p-input-number [step]="0"
                              [tabindex]="7" inputStyleClass="text-right" id="eingEinstand" [maxFractionDigits]="3"
                              [minFractionDigits]="3" [step]="0"
                              appLeadingZero formControlName="inputEinstand" locale="de-DE" mode="decimal"
                              class="w-full"/>
            </p-iconfield>
            <p-inputgroup-addon>%</p-inputgroup-addon>
          </p-input-group>
        </div>
      }
      @if (isDzUser) {
        <div class="flex flex-row align-items-center w-28rem">
          <label class="w-13rem" for="geschMargeId">
            {{ "investment.label.zins.marge" | translate }}
          </label>
          <p-input-group>
            @if (!storno) {
              @if (tagesgeldMitBestand || korrektur) {
                <!-- MARGE Geschaeft -->
                <p-iconfield no-border-right class="form-zins-spinner">
                  @if (isInterestLoading()) {
                    <p-inputicon class="pi pi-spinner pi-spin"></p-inputicon>
                  }
                  <input pInputText formControlName="geschMarge" id="geschMargeId"
                         [class.text-error]="!hasGeschInterestRate()"
                         class="w-full text-right"/>
                </p-iconfield>
              }

              <!-- MARGE System -->
              <p-iconfield [attr.no-border]="(korrektur || tagesgeldMitBestand) ? '' : null"
                           [attr.no-border-right]="!korrektur ? '' : null"
                           class="form-zins-spinner">
                @if (isInterestLoading()) {
                  <p-inputicon class="pi pi-spinner pi-spin"></p-inputicon>
                }
                <input pInputText inputStyleClass="text-right" formControlName="systemMarge"
                       class="w-full text-right" [class.text-error]="!hasInterestRate()"/>
              </p-iconfield>
            }

            <!-- MARGE Eingabe -->
            <p-iconfield [attr.no-border]="!storno ? '' : null" [attr.no-border-right]="storno ? '' : null"
                         [class.w-full]="storno"
                         class="form-zins-spinner">
              @if (isInterestLoading()) {
                <p-inputicon class="pi pi-spinner pi-spin"/>
              }
              <p-input-number [step]="0"
                              [tabindex]="8" inputStyleClass="text-right" [maxFractionDigits]="3"
                              [minFractionDigits]="3"
                              formControlName="inputMarge" locale="de-DE" appLeadingZero [step]="0"
                              mode="decimal" class="w-full"/>
            </p-iconfield>
            <p-inputgroup-addon>%</p-inputgroup-addon>
          </p-input-group>
        </div>
      }
      <div class="flex flex-row align-items-center w-28rem">
        <label class="w-13rem" for="geschZinssatzId">
          {{ "investment.label.zins.zinssatz" | translate }}
        </label>
        <p-input-group>
          @if (!storno) {
            @if ((tagesgeldMitBestand || korrektur) && isDzUser) {
              <!-- Zinssatz Geschaeft -->
              <p-iconfield no-border-right class="form-zins-spinner">
                @if (isInterestLoading()) {
                  <p-inputicon class="pi pi-spinner pi-spin"></p-inputicon>
                }
                <input pInputText formControlName="geschZinssatz" id="geschZinssatzId"
                       [class.text-error]="!hasGeschInterestRate()"
                       class="w-full text-right" [step]="0"/>
              </p-iconfield>
            }
            <!-- Zinssatz System -->
            @if (isDzUser) {
              <p-iconfield [attr.no-border]="(korrektur || tagesgeldMitBestand) ? '' : null"
                           [attr.no-border-right]="!korrektur ? '' : null"
                           class="form-zins-spinner">
                @if (isInterestLoading()) {
                  <p-inputicon class="pi pi-spinner pi-spin"/>
                }
                <input pInputText formControlName="systemZinssatz" class="w-full text-right"
                       [class.text-error]="!hasInterestRate()"/>
              </p-iconfield>
            } @else {
              <p-iconfield no-border-right class="form-zins-spinner">
                @if (isInterestLoading()) {
                  <p-inputicon class="pi pi-spinner pi-spin"/>
                }
                <input pInputText formControlName="systemZinssatz" class="w-full text-right"
                       [class.text-error]="!hasInterestRate()"/>
              </p-iconfield>
            }


          }
          @if (isDzUser) {
            <p-iconfield [attr.no-border]="!storno ? '' : null" [attr.no-border-right]="storno ? '' : null"
                         [class.w-full]="storno">
              @if (isInterestLoading()) {
                <p-inputicon class="pi pi-spinner pi-spin"></p-inputicon>
              }
              <p-input-number [step]="0"
                              [tabindex]="9" inputStyleClass="text-right" [maxFractionDigits]="3"
                              [minFractionDigits]="3"
                              appLeadingZero
                              formControlName="inputZinssatz" locale="de-DE" mode="decimal" class="w-full" [step]="0"/>
            </p-iconfield>
          }
          <p-inputgroup-addon>%</p-inputgroup-addon>
        </p-input-group>
      </div>

      @if (isDzUser && ((tradeTransactionType === SimpleHgType.Tagesgeld && !isAnlageCallMoney) || renderFesterZinsFeld)) {
        <div class="flex flex-row align-items-center w-28rem mt-2 mb-2">
          <label class="w-13rem" for="festerZinsId">{{ "investment.label.zins.fixed" | translate }}</label>
          <p-checkbox class="ml-auto" formControlName="festerZins" [binary]="true" [readonly]="storno ?? storno"
                      id="festerZinsId"/>
        </div>
      }
      @if (isDzUser) {

        <div class="flex flex-row align-items-center w-28rem">
          <label class="w-13rem" for="form_zins_method">
            {{ "investment.label.zins.method" | translate }}
          </label>

          <p-input-group class="w-28rem">
            @if (tradeTransaction().zinsmethode) {
              <p-inputgroup-addon id="form_zins_method" class="w-full justify-content-start">
                {{ "investment.label.zins." + tradeTransaction().zinsmethode | translate }}
              </p-inputgroup-addon>
            } @else {
              <p-select appendTo="body" [disabled]="true"/>
            }
          </p-input-group>

        </div>

      }
      @if (showZinsperiodeFeld) {
        <div class="flex flex-row align-items-center w-28rem">
          <label class="w-13rem" for="periodId">
            {{ "investment.label.zins.period" | translate }}
          </label>
          <p-input-group>
            @if (isZinsperiodeSelectable) {
              <p-select [tabindex]="10" appendTo="body" [options]="interestPeriodeType" formControlName="period"
                        id="periodId">
                <ng-template let-period pTemplate="selectedItem">
                  {{ "investment.label.zins." + period | translate }}
                </ng-template>
                <ng-template let-period pTemplate="item">
                  {{ "investment.label.zins." + period | translate }}
                </ng-template>
              </p-select>
            } @else {
              <p-inputgroup-addon class="w-full justify-content-start">
                {{ "investment.label.zins." + tradeTransaction().zinsperiode | translate }}
              </p-inputgroup-addon>
            }
          </p-input-group>
        </div>
      }
    </div>
  </div>
}
